import { render, staticRenderFns } from "./global_notes_detailed.vue?vue&type=template&id=27ae72fa&scoped=true"
import script from "./global_notes_detailed.vue?vue&type=script&lang=js"
export * from "./global_notes_detailed.vue?vue&type=script&lang=js"
import style0 from "./global_notes_detailed.vue?vue&type=style&index=0&id=27ae72fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae72fa",
  null
  
)

export default component.exports